var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / tick@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1745198,14.8960572 L6.70913242,11.4306698 C6.31958354,11.0411209 5.68834481,11.0400056 5.29742187,11.4281756 L5.29451984,11.4310572 C4.90378081,11.8190445 4.90155013,12.450327 5.28953747,12.841066 C5.29036493,12.8418993 5.29119386,12.8427312 5.29202425,12.8435616 L10.1745198,17.7260572 L10.1745198,17.7260572 L19.0997136,8.7024117 C19.4865845,8.31127333 19.4848562,7.68109778 19.0958457,7.29208729 L19.0940846,7.29032614 C18.706983,6.90322462 18.0793675,6.90322462 17.692266,7.29032614 C17.6909064,7.29168573 17.6895507,7.29304928 17.6881991,7.29441677 L10.1745198,14.8960572 L10.1745198,14.8960572 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-tick"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#fff",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c873cd21da2c3c3164de278609363e24.svg";
export { ForwardRef as ReactComponent };